import AspectRatioCode from "!!raw-loader!./images/AspectRatio.tsx";
import ContainerCode from "!!raw-loader!./images/Container.tsx";
import ErrorCode from "!!raw-loader!./images/Error.tsx";
import IconCode from "!!raw-loader!./images/Icon.tsx";
import LargeCode from "!!raw-loader!./images/Large.tsx";
import LargestCode from "!!raw-loader!./images/Largest.tsx";
import LightboxCode from "!!raw-loader!./images/Lightbox.tsx";
import MediumCode from "!!raw-loader!./images/Medium.tsx";
import NodeCode from "!!raw-loader!./images/Node.tsx";
import RoundedCode from "!!raw-loader!./images/Rounded.tsx";
import SmallCode from "!!raw-loader!./images/Small.tsx";
import SmallestCode from "!!raw-loader!./images/Smallest.tsx";
import TurntableImageCode from "!!raw-loader!./images/TurntableImage";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import AspectRatio from "./images/AspectRatio";
import Container from "./images/Container";
import ImageError from "./images/Error";
import Icon from "./images/Icon";
import Large from "./images/Large";
import Largest from "./images/Largest";
import Lightbox from "./images/Lightbox";
import Medium from "./images/Medium";
import Node from "./images/Node";
import Rounded from "./images/Rounded";
import Small from "./images/Small";
import Smallest from "./images/Smallest";
import TurntableImage from "./images/TurntableImage";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Empty or Error", ErrorCode, ImageError),
		paneComponent("Images from Node", NodeCode, Node),
		paneComponent("Turntable Image Box", TurntableImageCode, TurntableImage),
		paneComponent("Icon", IconCode, Icon),
		paneComponent("Smallest", SmallestCode, Smallest),
		paneComponent("Small", SmallCode, Small),
		paneComponent("Medium", MediumCode, Medium),
		paneComponent("Large", LargeCode, Large),
		paneComponent("Largest", LargestCode, Largest),
		paneComponent(
			"Aspect Ratio",
			AspectRatioCode,
			AspectRatio,
			"The height of the image container is driven by the aspect ratio and width (good for flexible layouts).",
		),
		paneComponent("Size to Container", ContainerCode, Container),
		paneComponent("Rounded", RoundedCode, Rounded),
		paneComponent("Lightbox", LightboxCode, Lightbox, "This is only a concept, and not full implementation of the lightbox component (Esc to close)."),
	];

	return (
		<Pane
			components={components}
			imports='import {Image} from "designSystem/index";'
			{...props}
		/>
	);
};
